import types from './types';

const getPersonAutocompleteListAction = (name, isNotMissingLmsCourses, showPersonalData) => ({
  type: types.GET_PERSON_AUTOCOMPLETE_LIST,
  params: { name, isNotMissingLmsCourses, showPersonalData }
});

export default {
  getPersonAutocompleteListAction
};
